<template>
  <div class="top">
    <div class="bottom">
      <div class="content">
        <div class="index">
          <span
            v-for="item in nav"
            :key="item.name"
            @click="navClick(item.path)"
            >{{ item.name }}</span
          >
        </div>
        <div class="law">
          <span
            >Copyright © 2024 宁波芯研瑞诺科技有限公司 &nbsp; ICP备2024120282号-1
          </span>
        </div>
      </div>
      <!-- <div class="img">
        <img src="~@/assets/code.jpg" alt="">
        <p>扫一扫，联系我们</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  data() {
    return {
      nav: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "公司简介",
          path: "/intro",
        },
        {
          name: "产品中心",
          path: "/product",
        },
        {
          name: "联系我们",
          path: "/contact",
        },
      ],
    };
  },
  methods: {
    navClick(path) {
      this.$router.push(path);
      // window.location.reload()
    },
  },
};
</script>

<style scoped>
.top {
  width: 100%;
  height: 170px;
  background-color: #444444;
  display: flex;
  justify-content: center;
}

.img {
}
.img p {
  margin: 0;
  color: #888888;
  font-size: 14px;
}
.img img {
  margin-top: 10px;
  width: 95px;
  height: 91px;
  border: 5px solid #3a8ee6;
}

.law {
  padding-top: 30px;
  color: #999999;
  font-size: 12px;
}
.index :hover {
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
}
@media screen and (min-width: 768px) {
  .content {
    width: 60%;
  }
  .bottom {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .index {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    border-bottom: 1px dashed #666666;
    padding-bottom: 30px;
    color: #cccccc;
  }
}
@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .index {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    border-bottom: 1px dashed #666666;
    padding-bottom: 30px;
    color: #cccccc;
  }
}
</style>
